/**
 * The option variant.
 * @param {'default'} Default
 * @param {'primary'} Primary
 */
export enum OptionVariant {
  Default = 'default',
  Primary = 'primary',
}

/**
 * The props interface of a option component.
 * @param {OptionVariant | undefined} variant
 * @param {string} children
 * @param {void | undefined} onRemove
 */
export interface OptionProps {

  /**
   * Variant of the theme.
   * @type {OptionVariant}
   */
  variant?: OptionVariant;

  /**
   * Children content in the option.
   * @type {string}
   */
  children: string;

  /**
   * Remove event.
   * @return {void}
   */
  onRemove?(): void;

}
